import React, { useState, useCallback, useMemo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ConfirmContext from '../contexts/ConfirmContext';

export function ConfirmProvider({ children }) {
  const [dialog, setDialog] = useState(null);

  const confirm = useCallback(({
    title = 'Confirm',
    message = 'Are you sure?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    variant = 'primary',
  } = {}) => {
    return new Promise(resolve => {
      setDialog({ title, message, confirmText, cancelText, variant, resolve });
    });
  }, []);

  const close = useCallback((result) => {
    setDialog(prev => {
      if (prev?.resolve) prev.resolve(result);
      return null;
    });
  }, []);

  const value = useMemo(() => ({ confirm }), [confirm]);

  return (
    <ConfirmContext.Provider value={value}>
      {children}
      <Modal show={Boolean(dialog)} onHide={() => close(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{dialog?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{dialog?.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => close(false)}>
            {dialog?.cancelText}
          </Button>
          <Button variant={dialog?.variant} onClick={() => close(true)}>
            {dialog?.confirmText}
          </Button>
        </Modal.Footer>
      </Modal>
    </ConfirmContext.Provider>
  );
}
